import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Grid, Typography } from '@mui/material';
import Link from '../Link';
import { PlayButton } from '../button';

/**
 * Lists episodes given a filter, tag or limit.
 *
 * @param {Object} param0
 * @returns
 */
const EpisodesList = ({ episodes, md, xs }) =>  (
    <>
      {episodes.map(
        (
          {
            node: {
              item: {
                title,
                guid,
                itunes: { subtitle },
                enclosure: { url },
              },
              itemImageFile: {
                childImageSharp: { gatsbyImageData },
              },
            },
          },
          index,
        ) => (
          <Grid
            container
            spacing={2}
            key={guid}
            size={{
              xs: xs || 12,
              md: md || 4
            }}>
            <Grid
              size={{
                xs: 4,
                md: 12
              }}>
              <Link to={`/podcast/episodes/${guid}/`}>
                <GatsbyImage image={gatsbyImageData} alt={title} />
              </Link>
            </Grid>
            <Grid
              size={{
                xs: 8,
                md: 12
              }}>
              <Link
                to={`/podcast/episodes/${guid}/`}
                sx={{ textDecoration: 'none' }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    marginTop: {
                      md: 2,
                    },
                    marginBottom: 2,
                  }}
                >
                  {title}
                </Typography>
              </Link>
              <Typography marginY={2}>{subtitle}</Typography>
              <PlayButton size="small" src={url} />
            </Grid>
          </Grid>
        ),
      )}
      {episodes.length === 0 && (
        <Typography>Die Episode wird bald veröffentlicht.</Typography>
      )}
    </>
  );

export default EpisodesList;
